import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withKeys as _withKeys, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ac07775"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PageSearch" }

import LfForm from '@/components/lf-form.vue'
import {
  withDefaults,
  ref,
  watch,
  computed,
  onBeforeUnmount
} from 'vue'
import { IForm } from './types'
import { useStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'PageSearch',
  props: {
    searchFormConfig: {},
    labelWidth: { default: '100px' }
  },
  emits: ["resetBtnClick", "searchBtnClick", "exportBtnClick", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const store = useStore()

const activeNames = computed(() => {
  return store.state.system.openOrClose ? '1' : ''
})

const formItems = props.searchFormConfig.formItems ?? []

const formOriginData: any = {}

for (const item of formItems) {
  formOriginData[item.field] =
    typeof item.defaultValue !== 'undefined' ? item.defaultValue : ''
}

const formData = ref(formOriginData)

const queryInfo = store.state.system.queryInfo
for (const key in queryInfo) {
  formData.value[key] = queryInfo[key]
}

const handleResetClick = () => {
  for (const key in formOriginData) {
    formData.value[key] = formOriginData[key]
  }
  emit('resetBtnClick')
  const queryInfo = store.state.system.queryInfo
  for (const key in queryInfo) {
    formData.value[key] = queryInfo[key]
  }
}
let searchTimer: ReturnType<typeof setTimeout> | null = null
const handleSearchClick = () => {
  if (searchTimer) {
    clearTimeout(searchTimer)
  }
  searchTimer = setTimeout(() => {
    emit('searchBtnClick', formData.value)
    searchTimer = null
  }, 300)
}
const handleExportClick = () => {
  emit('exportBtnClick', formData.value)
}

onBeforeUnmount(() => {
  if (searchTimer) {
    clearTimeout(searchTimer)
    searchTimer = null
  }
})

watch(
  formData,
  (newValue) => {
    emit('change', newValue)
  },
  {
    deep: true
  }
)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElCollapseItem = _resolveComponent("ElCollapseItem")!
  const _component_ElCollapse = _resolveComponent("ElCollapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ElCollapse, {
      modelValue: activeNames.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeNames).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ElCollapseItem, {
          title: "",
          name: "1"
        }, {
          default: _withCtx(() => [
            _createVNode(LfForm, _mergeProps(_ctx.searchFormConfig, {
              modelValue: formData.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event)),
              onKeyup: _withKeys(handleSearchClick, ["enter","native"]),
              labelWidth: _ctx.labelWidth
            }), {
              footer: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(
                _ctx.searchFormConfig.formItems.filter((o) => !o.isHidden).length %
                  3 >
                0
                  ? 'handle-btns-last'
                  : 'handle-btns'
              )
                }, [
                  _createVNode(_component_el_button, {
                    icon: "el-icon-refresh",
                    onClick: handleResetClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("重置")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    icon: "el-icon-search",
                    onClick: handleSearchClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("搜索")
                    ]),
                    _: 1
                  })
                ], 2)
              ]),
              _: 1
            }, 16, ["modelValue", "labelWidth"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})